import { processCellForExportSelector } from "./export-handlers/process-cell-for-export-selector";
import { handleBodyScrollEnd as handleBodyScrollEndUtil } from "./grid-scroll-utils";
import { adjustHorizontalScroll } from "./insGrid-helpers";
export const createProcessCellForClipboard = (dataScale) => (params) => processCellForExportSelector({ dataScale, ...params });
export const createHandleBodyScrollEnd = (grid, onBodyScrollverticalEndToTheBottom) => (e) => handleBodyScrollEndUtil({
    event: e,
    gridRef: grid,
    onBodyScrollverticalEndToTheBottom
});
export const createHandleColumnGroupOpened = (grid) => () => adjustHorizontalScroll(grid);
export const createOnSelectionChanged = (rowSelectedHandler) => (event) => {
    if (rowSelectedHandler) {
        rowSelectedHandler(event);
    }
};
